<nav class="navbar p-0" [ngClass]="{ 'closed': isClosed }" [class.sticky]="isNavbarSticky">
  <div class="sidebar">
    <button class="toggle-btn" (click)="toggleSidebar()"><i class="fa-solid fa-arrow-left"></i></button>
    <ul>
<!--      <li class="no-hover nav-search">-->
<!--        <i class="fa-solid fa-magnifying-glass"></i>-->
<!--        <input type="text" placeholder="Search..." />-->
<!--      </li>-->
      <li [ngClass]="{ 'active': selected === 'Dashboard' }" (click)="selectItem('Dashboard', 'dashboard')">
        <i class="fa-solid fa-dashboard"></i>
        <p>{{ 'shared.navbar.dashboard' | translate }}</p>
      </li>
      <li [ngClass]="{ 'active': selected === 'Case Management' }" (click)="selectItem('Case Management', 'case-management')" *ngIf="!isAdmin">
        <i class="fa-solid fa-book"></i>
        <p>{{ 'shared.navbar.caseManagement' | translate }}</p>
      </li>
      <li [ngClass]="{ 'active': selected === 'Working Groups' }" (click)="selectItem('Working Groups', 'working-groups')" *ngIf="!isAdmin">
        <i class="fa-solid fa-folder"></i>
        <p>{{ 'shared.navbar.workingGroups' | translate }}</p>
      </li>
<!--      <li [ngClass]="{ 'active': selected === 'Community Content' }" (click)="selectItem('Community Content', 'community-content')">-->
<!--        <i class="fa-solid fa-compass"></i>-->
<!--        <p>{{ 'shared.navbar.communityContent' | translate }}</p>-->
<!--      </li>-->
      <li [ngClass]="{ 'active': selected === 'Notifications' }" (click)="openNotificationPanel()" *ngIf="!isAdmin">
        <i class="fa-solid fa-envelope"></i>
        <p>{{ 'shared.navbar.notifications' | translate }}</p>
        <p class="notification-count">{{ recentNotificationsCount$ | async }}</p>
      </li>
      <li [ngClass]="{ 'active': selected === 'Users' }" (click)="selectItem('Users', 'users')">
        <i class="fa-solid fa-user"></i>
        <p>{{ 'shared.navbar.users' | translate }}</p>
      </li>
      <li [ngClass]="{ 'active': selected === 'FIU Management' }" (click)="selectItem('FIU Management', 'fiu-management')" *ngIf="!(loggedInUser?.role?.roleName.toLowerCase().includes('analyst'))">
        <i class="fa-solid fa-flag"></i>
        <p>{{ 'shared.navbar.fiuManagement' | translate }}</p>
      </li>
<!--      Commented out until needed-->
<!--      <li [ngClass]="{ 'active': selected === 'Chat' }" (click)="selectItem('Chat', 'chat')">-->
<!--        <i class="fa-solid fa-message"></i>-->
<!--        <p>Chat</p>-->
<!--      </li>-->
    </ul>

    <ul class="lower-nav">
      <li [ngClass]="{ 'active': selected === 'Support' }" (click)="selectItem('Support', 'support')" *ngIf="!isAdmin">
        <i class="fa-solid fa-life-ring"></i>
        <p>{{ 'shared.navbar.support' | translate }}</p>
      </li>
      <li class="nav-section-title" *ngIf="canManageCaseCategories">
        <p>Configuration</p>
      </li>
      <li [ngClass]="{ 'active': selected === 'Case Categories' }" (click)="selectItem('Case Categories', 'case-management/case-categories')" *ngIf="canManageCaseCategories">
        <i class="fa-solid fa-cog"></i>
        <p>Case Categories</p>
      </li>
      <li [ngClass]="{ 'active': selected === 'Request Types' }" (click)="selectItem('Request Types', 'case-management/request-types')" *ngIf="canManageCaseCategories">
        <i class="fa-solid fa-clock"></i>
        <p>Request Types</p>
      </li>
<!--      Commented out until needed-->

<!--      <li (click)="toggleTheme()">-->
<!--        <i class="fa-solid fa-moon"></i>-->
<!--        <p>Toggle Theme</p>-->
<!--      </li>-->
<!--      <li class="no-hover">-->
<!--          <div class="case-card">-->
<!--              <div class="card-content">-->
<!--                  <div class="heading-container">-->
<!--                      <i class="fa-solid fa-tasks"></i>-->
<!--                      <h3 class="heading">5 cases open</h3>-->
<!--                  </div>-->
<!--                  <p class="paragraph">Case number (No. 345) has been in the backlog for 13 days now. <a>Update Now</a></p>-->
<!--                  <button class="dismiss-button">Dismiss</button>-->
<!--              </div>-->
<!--          </div>-->
<!--      </li>-->

      <li class="user-info-container">
        <i class="fa-solid fa-user"></i>
        <div class="user-info">
          <p class="username">{{ loggedInUser?.firstName }} {{ loggedInUser?.lastName }}</p>
          <p class="role">{{ loggedInUser?.role?.roleName }}</p>
        </div>
<!--        <i class="fa-solid fa-door-open" (click)="logout()"></i>-->
        <div class="popup">
          <section class="user-info">
            <h5>{{ 'shared.navbar.userInfo' | translate }}</h5>
            <p><span>{{ 'shared.navbar.name' | translate }}</span> {{ loggedInUser?.firstName }} {{ loggedInUser?.lastName }}</p>
            <p><span>{{ 'shared.navbar.email' | translate }}</span> {{ loggedInUser?.emailAddress }}</p>
            <p><span>{{ 'shared.navbar.role' | translate }}</span> {{ loggedInUser?.role?.roleName }}</p>
          </section>

          <section class="fiu-info">
            <h5>{{ 'shared.navbar.fiuInfo' | translate }}</h5>
            <span class="country fi fis" [ngClass]="loggedInUser?.fiu?.logo"></span>
            <p><span>{{ 'shared.navbar.fiuName' | translate }}</span> {{ loggedInUser?.fiu?.fiuName }}</p>
            <p><span>{{ 'shared.navbar.fiuStatus' | translate }}</span> {{ loggedInUser?.fiu?.fiuStatus }}</p>
          </section>
        </div>
<!--        <i class="fa-solid fa-door-open" (click)="logout()"></i>-->
      </li>
      <p class="version-info">UI Version: {{ appVersion }}</p>
      <p class="version-info">API Version: {{ apiVersion }}</p>
      <p class="copyright-info">ESAAMLG © 2024</p>
      <p class="copyright-info">E-Information Exchange Platform System (E-IEPS)</p>
    </ul>
  </div>
</nav>
<notification-panel [openPanel]="openPanel" (panelClosed)="onPanelClosed($event)" [notificationData]="notifications$ | async"></notification-panel>
